
import { useDispatch, useSelector } from 'react-redux'

import { Dialog } from 'primereact/dialog'
import { toggleDialog } from '../../../../../../redux/Slices/Global/globalSlice'
import ContainerPreview from './Warning_preview/ContainerPreview'
import { Button } from '../../../../../../components/ui/Button';
import DynamicContainerPreview from './Warning_preview/DynamicContainerPreview'
import { useTranslation } from 'react-i18next'


const LayoutConflictWarning = ({ custom = false, setAreas, currentAspectRatio = null, newAreas = null, isLoading, oldLayout, oldAspectRatio, newLayout, setOldLayout, handleChange }) => {
    const { t } = useTranslation()
    const dispatch = useDispatch()
    const { screens_setting, selectedTemplate } = useSelector((state) => state.layout);



    const openDialog = useSelector((state) => state.global.openDialog);
    const onConfirm = () => {
        // setOldLayout(newLayout);
        if (custom) {
            handleChange()
        } else { handleChange(screens_setting, selectedTemplate); }
        dispatch(toggleDialog("layoutConflict"));

    };

    const onClose = () => {
        if (custom) {
            setAreas(newAreas)
        }
        dispatch(toggleDialog("layoutConflict"))
    }
    const header = (
        <div className="flex items-center gap-2 text-warning-700">
            <i className="fa-solid fa-triangle-exclamation text-yellow-600" />
            <span className="text-lg font-semibold">{t('layouts.setup_layout_conflict')}</span>
        </div>
    );

    const footer = (
        <div className="flex justify-center gap-3 px-4 pb-3">
            <Button
                disabled={isLoading}
                label={t('buttons.cancel')}
                className="bg-gray-200 text-gray-800 border-none hover:bg-gray-300"
                onClick={onClose}
            />
            <Button
                disabled={isLoading}
                loading={isLoading}
                label={t('buttons.confirm')}
                className="bg-yellow-600 text-white border-none hover:bg-yellow-300"
                onClick={onConfirm}
            />
        </div>
    );


    return (
        <Dialog
            id="confect_dialog_layout"
            visible={openDialog.layoutConflict}
            breakpoints={{ '960px': "75vh", }}
            className="rounded-xl shadow-lg"
            header={header}
            footer={footer}
            modal
            //  className="p-fluid"
            style={{ width: '35vw', borderRadius: '12px', background: 'rgb(239 209 148 / 75%)' }}
            contentStyle={{ background: 'transparent', borderRadius: '12px', padding: '20px' }}

            onHide={onClose}>

            <div className="text-center  flex flex-col    font-medium alert  p-2" >
                <div className="flex gap-5 justify-center justify-items-center text-center ">
                    {/* Preview Area */}
                    {custom ?
                        <DynamicContainerPreview areas={oldLayout}
                            currentAspectRatio={oldAspectRatio} />

                        :
                        <ContainerPreview
                            areas={oldLayout}
                            currentAspectRatio={oldAspectRatio}
                        />
                    }


                    <div className="mx-4 flex items-center justify-center">
                        <i className="fa-solid fa-angles-right text-xl"></i>
                    </div>
                    {custom ?
                        <DynamicContainerPreview areas={newLayout}
                            currentAspectRatio={currentAspectRatio} />

                        :
                        <ContainerPreview
                            areas={newLayout}
                            currentAspectRatio={selectedTemplate.aspect_ratio}
                        />
                    }


                </div>

                <div className="flex mt-3 justify-center w-100">
                    <i className=" text-end ml-3 mr-3 mt-4 fa-solid fa-triangle-exclamation fa-lg"></i>
                    <div className="  w-75">
                        {t('layouts.setup_conflict_warning_text')}
                    </div>
                </div>

            </div>

        </Dialog>
    )
}

export default LayoutConflictWarning
